module.exports = __webpack_public_path__ + "mainassets/img/faq-4.5597797a.svg";